import type { SeparatorAttributes } from '../../types/contactPage'
import { CmsButton } from '../Button'
import { SeparatorContainer } from './styles'
import { Grid, Container } from '@mui/material'
import { MarkdownText } from 'ui-kit'

const Separator = ({
  title,
  backgroundColour,
  button,
  body = '',
}: SeparatorAttributes) => {
  return (
    <SeparatorContainer bgColour={backgroundColour}>
      <Container maxWidth={body ? 'lg' : 'md'}>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item>
            <MarkdownText>{title ?? ''}</MarkdownText>
            {body ? <MarkdownText>{body}</MarkdownText> : null}
          </Grid>
          <Grid item>
            <CmsButton
              href={button?.link ?? ''}
              rel={button?.rel}
              target={button?.target}
              backgroundColor={button?.backgroundColour ?? '#000'}
              color={button?.textColour ?? '#FFF'}
            >
              {button?.text ?? ''}
            </CmsButton>
          </Grid>
        </Grid>
      </Container>
    </SeparatorContainer>
  )
}

export default Separator
